export default function inboundReducer(inbound, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "exten":
      return { ...inbound, [action.type]: action.value ? Number(action.value).toString() : "" };
    case "forceCaller":
      return { ...inbound, forceCallerId: null };

    case "addWebhook":
      return { ...inbound, webhooks: [...inbound.webhooks, action.webhook] };
    case "removeWebhook":
      return { ...inbound, webhooks: inbound.webhooks.filter((_webhook) => _webhook.id !== action.webhook.id) };

    default:
      return { ...inbound, [action.type]: action.value };
  }
}
